function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21994"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20007",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17774",
    d: "M10 18a8 8 0 1 0-8-8 8 8 0 0 0 8 8zM8.707 7.293a1 1 0 1 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 1 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 1 0-1.414-1.414L10 8.586z",
    transform: "translate(5 5)",
    style: {
      fill: "#f7575f",
      fillRule: "evenodd"
    }
  })));
};

export default SvgError;